import { ShippedHazardousGoods } from '@nx-smartmonkey/shared/domain';

export const TRANSPORT_MODE = [
  { value: `car`, labelId: `traffic_options.details.mode.car` },
  { value: `truck`, labelId: `traffic_options.details.mode.truck` },
  { value: `bicycle`, labelId: `traffic_options.details.mode.bicycle` },
  { value: `pedestrian`, labelId: `traffic_options.details.mode.pedestrian` },
];

export const TRAFFIC_MULTIPLIER_VALUES = [
  {
    value: 2.5,
    labelId: `traffic_options.details.multiplier.very_slow`,
  },
  {
    value: 2,
    labelId: `traffic_options.details.multiplier.slow`,
  },
  {
    value: 1.4,
    labelId: `traffic_options.details.multiplier.normal`,
  },
  {
    value: 1.2,
    labelId: `traffic_options.details.multiplier.fast`,
  },
];

export const SHIPPED_HAZARDOUS_GOODS = [
  {
    value: `explosive` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.explosive`,
  },
  { value: `gas` as ShippedHazardousGoods, labelId: `traffic_options.details.truck.shipped_hazardous_goods.gas` },
  {
    value: `flammable` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.flammable`,
  },
  {
    value: `combustible` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.combustible`,
  },
  {
    value: `organic` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.organic`,
  },
  { value: `poison` as ShippedHazardousGoods, labelId: `traffic_options.details.truck.shipped_hazardous_goods.poison` },
  {
    value: `radioactive` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.radioactive`,
  },
  {
    value: `corrosive` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.corrosive`,
  },
  {
    value: `poisonousInhalation` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.poisonousInhalation`,
  },
  {
    value: `harmfulToWater` as ShippedHazardousGoods,
    labelId: `traffic_options.details.truck.shipped_hazardous_goods.harmfulToWater`,
  },
  { value: `other` as ShippedHazardousGoods, labelId: `traffic_options.details.truck.shipped_hazardous_goods.other` },
];
